import ApplicationController from "application_controller.js";
import { jarallax, jarallaxVideo } from "jarallax";


// TODO handle youtube video backgrounds when user rejects third party cookies.
export default class extends ApplicationController  {
  debug = false;

  static targets = [ "imageContainer" ];

  static values = {
    enabled: { type: Boolean, default: true },
    videoSrc: { type: String, default: "" },
  };

  connect() {
    this.log_function("connect");

    if(this.videoSrcValue) {
      this.log_function("connect", "videoSrc", this.videoSrcValue);
      jarallaxVideo();
    }

    this.init_attempts = 0;
    this.max_init_attempts = 5;

    this.interval = setInterval(() => {

      if(this.init_attempts > this.max_init_attempts){
        clearInterval(this.interval);
        return false;
      }

      const image = this.image;

      if (image) {
        this.element.classList.add("jarallax");
        image.classList.add("jarallax-img");
        jarallax(this.element, this.config);
        // After jarallax: its init() resets the element's background-image to none.
        this.showImageBehindDivider(image);
        clearInterval(this.interval);
      }

      this.init_attempts++;
    }, 1000);
  }

  // iOS Safari draws the page under its floating toolbar, below the 100vh where the fixed
  // jarallax image ends, and jarallax leaves the image in flow under prefers-reduced-motion.
  // Either way the divider's own background shows, so make it the same photo.
  showImageBehindDivider(image){
    const src = image.currentSrc || image.src;
    if (!src) return;

    Object.assign(this.element.style, {
      backgroundImage: `url("${src}")`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    });
  }

  handleVideoInsert(){
    this.log_function("handleVideoInsert");
    this.element.classList.add("loaded");
  }

  disconnect(){
    this.log_function("disconnect");

    /* istanbul ignore else -- connect always sets the interval, and setInterval never returns 0 */
    if(this.interval) {
      clearInterval(this.interval);
    }

    jarallax(this.element, "destroy");
  }

  get image() {
    /* istanbul ignore else -- Stimulus throws for a missing target, so imageContainerTarget is never falsy */
    if (this.imageContainerTarget) {
      const imageElement = this.imageContainerTarget.querySelector("img");
      return imageElement || null;
    }
    /* istanbul ignore next -- unreachable, see the ignore above */
    return null;
  }

  get config(){
    this.log_function("get config");

    //* https://github.com/nk-o/jarallax/blob/master/README.md#options
    return {
      type: "scroll",
      speed: 0,
      videoSrc: this.videoSrcValue,
      onVideoInsert: this.handleVideoInsert.bind(this),
      disableParallax: !this.enabledValue,
    };
  }
}
